import(/* webpackChunkName: "chargeBack" */ '../Styles/chargeBack.scss');

await import(/* webpackChunkName: "headline" */ 'Foundation/ContentElements/code/Common/Styles/headline.scss');
await import(/* webpackChunkName: "sync" */ 'Feature/Common/code/Scripts/Common/sync');
await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');
await import(/* webpackChunkName: "ajax" */ 'Feature/Common/code/Scripts/Common/ajax');
await import(/* webpackChunkName: "tools" */ 'Common/Scripts/Common/tools');
await import(/* webpackChunkName: "groupFormat" */ 'Foundation/Common/code/Scripts/Common/groupFormat');
await import(/* webpackChunkName: "lotteryTicketFormat" */ 'Foundation/LotteryTicket/code/Scripts/LotteryTicket/lotteryTicketFormat');
await import(/* webpackChunkName: "lotteryTicketStartNumbers" */ 'Foundation/LotteryTicket/code/Scripts/LotteryTicket/lotteryTicketStartNumbers');
await import(/* webpackChunkName: "requiredAdvanced" */ 'Foundation/Forms/code/Scripts/requiredAdvanced');
await import(/* webpackChunkName: "requiredWhen" */ 'Foundation/Forms/code/Scripts/requiredWhen');
await import(/* webpackChunkName: "input-mask" */ 'Foundation/Forms/code/Scripts/input-mask');
await import(/* webpackChunkName: "iban" */ 'Foundation/Forms/code/Scripts/iban');

await import(/* webpackChunkName: "forms" */ 'Feature/Forms/code/Scripts/forms');

window.am = window.am || {};

window.am.chargeBack = new function () {
    var that = this;
    that.inputErrorClass = 'input-error';
    let host = window.location.origin;
    let prevCancelOrPauseDeadline = document.querySelector(".chargeback__cancelorpause-deadline");
    if (prevCancelOrPauseDeadline) {
        prevCancelOrPauseDeadline = document.querySelector(".chargeback__cancelorpause-deadline").innerText;
    }
    let chargebackTileInformation = document.querySelectorAll(".chargeback__tile__information ul li");
    let chargebackStepText = document.querySelector(".chargeback__summary__step-infotext");

    that.init = function () {
        initPartialUpdateForms();
    }


    /* Summary Step updating partial forms*/
    function initPartialUpdateForms() {

        var formDataContainers = document.querySelectorAll('.chargeback__submitdata__form-data-container, .chargeback__summary__form-data-container');

        var summaryButtonArreas = document.querySelectorAll('div.chargeback__button-area');
        if (summaryButtonArreas) {
            for (var k = 0; k < summaryButtonArreas.length; k++) {
                let summaryButtonArrea = summaryButtonArreas[k];
                if (window.getComputedStyle(summaryButtonArrea).display.includes("none")) {
                    continue;
                }
                var summarySubmitButton = summaryButtonArrea.querySelector('button[type="submit"].chargeback__summary__linkbutton, button[type="submit"].chargeback__submitdata__linkbutton');
                var summarySubmitButtonInfo = summaryButtonArrea.querySelector('div.chargeback__summary__linkbutton-disabled-info, div.chargeback__submitdata__linkbutton-disabled-info');
            }
        }

        for (let i = 0; i < formDataContainers.length; i++) {


            let container = formDataContainers[i];

            let editButton = container.querySelector('.edit-button');

            if (editButton == null) {
                continue;
            }

            let viewContainer = container.querySelector('.view');

            let discardButton = container.querySelector('.discard-button');

            let viewAdditionalContainer = container.querySelector('.view-additional');

            let editContainer = container.querySelector('.edit');

            editButton.addEventListener('click', function (e) {

                activateEditPartialAjaxForm(this, container, discardButton, viewContainer, editContainer, viewAdditionalContainer);
            }, false);

            editButton.addEventListener('keydown', function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    activateEditPartialAjaxForm(this, container, discardButton, viewContainer, editContainer, viewAdditionalContainer);
                }
            }, false);

            

            let ajaxFormWrapper = editContainer.querySelector('.partial-ajax-form');

            if (ajaxFormWrapper == null) {
                continue;
            }

            let ajaxForm = ajaxFormWrapper.querySelector('form');

            if (ajaxForm == null) {
                continue;
            }

            $(ajaxForm).data("validator").settings.submitHandler = function (form) {
                submitHandler(ajaxFormWrapper, form, viewContainer, editContainer, editButton, discardButton, viewAdditionalContainer, summarySubmitButton, summarySubmitButtonInfo);
            };
        }

        function activateEditPartialAjaxForm(editButton, container, discardButton, viewContainer, editContainer, viewAdditionalContainer) {

            //disable a main form submit button while edditing partial form                
            if (summarySubmitButton && !summarySubmitButton.hasAttribute('disabled')) {
                summarySubmitButton.setAttribute('disabled', '');
                if (summarySubmitButtonInfo) {
                    summarySubmitButtonInfo.classList.remove('d-none')
                }
            }

            for (let j = 0; j < formDataContainers.length; j++) {
                let otherContainer = formDataContainers[j];

                if (otherContainer == container) {
                    continue;
                }

                let otherEditButton = otherContainer.querySelector('.edit-button');

                let otherDiscardButton = otherContainer.querySelector('.discard-button');

                let otherViewContainer = otherContainer.querySelector('.view');

                let otherViewAdditionalContainer = otherContainer.querySelector('.view-additional');

                let otherEditContainer = otherContainer.querySelector('.edit');

                otherEditButton.classList.remove('d-none');

                otherDiscardButton.classList.add('d-none');

                otherViewContainer.classList.remove('d-none');

                if (otherViewAdditionalContainer) {
                    otherViewAdditionalContainer.classList.remove('d-none');
                }


                otherEditContainer.classList.add('d-none');
            }

            editButton.classList.add('d-none');

            viewContainer.classList.add('d-none');

            discardButton.classList.remove('d-none');

            if (viewAdditionalContainer) {
                viewAdditionalContainer.classList.add('d-none');
            }

            editContainer.classList.remove('d-none');

            discardButton.addEventListener('click', function (e) {
                hideEditPartialFormAjaxForm(editButton, this, viewContainer, editContainer, viewAdditionalContainer);
            });

            discardButton.addEventListener('keydown', function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault;
                    hideEditPartialFormAjaxForm(editButton, this, viewContainer, editContainer, viewAdditionalContainer);
                }
            }, false);

            function hideEditPartialFormAjaxForm(editButton, discardButton, viewContainer, editContainer, viewAdditionalContainer) {

                discardButton.classList.add('d-none');

                viewContainer.classList.remove('d-none');
                if (viewAdditionalContainer) {
                    viewAdditionalContainer.classList.remove('d-none');
                }
                editButton.classList.remove('d-none');

                editContainer.classList.add('d-none');

                if (summarySubmitButton && summarySubmitButton.hasAttribute('disabled')) {
                    summarySubmitButton.removeAttribute('disabled');
                    if (summarySubmitButtonInfo) {
                        summarySubmitButtonInfo.classList.add('d-none')
                    }
                }
            }
        };
    }

    const submitHandler = function (currentAjaxFormWrapper, form, viewContainer, editContainer, editButton, discardButton, viewAdditionalContainer, summarySubmitButton, summarySubmitButtonInfo) {

        var formName = form.getAttribute('data-form') || '';

        var formData = new FormData(form);

        $.ajax({
            url: form.action,
            method: form.method,
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {

                if (response.IsSuccessful) {

                    for (let propIndex in response.Data) {
                        let prop = response.Data[propIndex];

                        updateElementByProperty(prop, viewContainer, editContainer, true, true);
                    }

                    if (summarySubmitButton && summarySubmitButton.hasAttribute('disabled')) {
                        summarySubmitButton.removeAttribute('disabled');
                        if (summarySubmitButtonInfo) {
                            summarySubmitButtonInfo.classList.add('d-none')
                        }
                    }

                    editButton.classList.remove('d-none');
                    discardButton.classList.add('d-none');
                    viewContainer.classList.remove('d-none');

                    if (viewAdditionalContainer) {
                        viewAdditionalContainer.classList.remove('d-none');
                    }

                    editContainer.classList.add('d-none');
                    let cancelOrPauseDeadlineElement = document.querySelector(".chargeback__cancelorpause-deadline");
                    
                    if (cancelOrPauseDeadlineElement) {
                        let cancelOrPauseDeadline = cancelOrPauseDeadlineElement.innerText;
                        if (chargebackTileInformation ) {
                            chargebackTileInformation.forEach(function (tile) {
                                var istextContentIncluded = tile.textContent.includes(prevCancelOrPauseDeadline);
                                if (istextContentIncluded) {
                                    tile.textContent = tile.textContent.replace(prevCancelOrPauseDeadline, cancelOrPauseDeadline);
                                }
                            })
                        }
                        if (chargebackStepText) {
                            var istextContentInInfoTextIncluded = chargebackStepText.textContent.includes(prevCancelOrPauseDeadline);
                            if (istextContentInInfoTextIncluded) {
                                if (cancelOrPauseDeadline === Window.CancelAtOnceOptionText) {
                                    chargebackStepText.textContent = chargebackStepText.textContent.replace(prevCancelOrPauseDeadline, Window.CancelAtOnceAsDateText);
                                } else {
                                    chargebackStepText.textContent = chargebackStepText.textContent.replace(prevCancelOrPauseDeadline, cancelOrPauseDeadline);
                                }
                            } else {
                                if (prevCancelOrPauseDeadline === Window.CancelAtOnceOptionText && chargebackStepText.textContent.includes(Window.CancelAtOnceAsDateText)) {
                                    chargebackStepText.textContent = chargebackStepText.textContent.replace(Window.CancelAtOnceAsDateText, cancelOrPauseDeadline);
                                }
                            }
                        }
                        prevCancelOrPauseDeadline = cancelOrPauseDeadline;
                    }

                } else if (!response.IsSuccessful && response.IsModelError) {
                    var fakeElement = document.createElement('div');
                    fakeElement.innerHTML = response.Data.trim();
                    var newAjaxFormWrapper = fakeElement.firstChild;
                    currentAjaxFormWrapper.parentNode.replaceChild(newAjaxFormWrapper, currentAjaxFormWrapper);

                    var $form = $(newAjaxFormWrapper.querySelector('form'));
                    window.am.forms.initializeForm($form);

                    $form.data("validator").settings.submitHandler = function (submitForm) {
                        submitHandler(newAjaxFormWrapper, submitForm, viewContainer, editContainer, editButton, discardButton, viewAdditionalContainer, summarySubmitButton, summarySubmitButtonInfo);
                    };

                    window.am.iban.init();
                    window.am.inputmask.init();
                }
                else {
                    window.location.href = response.Data.Url;
                }
            },
            error: function () {
                console.log("error");
            }
        });
    };


    function updateElementByProperty(prop, viewContainer, editContainer, setValue, isCurrent) {

        var fieldName = prop.Key;
        var fieldValue = prop.Value;
        var hasChanged = prop.HasChanged;

        if (fieldValue == null) {
            return;
        }

        var updateElement = viewContainer.querySelector('[data-form-name="' + fieldName + '"]');

        if (updateElement == null) {
            return;
        }

        if (setValue && setValue == true) {
            var fieldElement = editContainer.querySelector('[name="' + fieldName + '"]');
            var displayName = fieldValue;

            /* Get name of the dropdown selected item */

            if (fieldElement.tagName.toLocaleLowerCase() == "select") {

                var selectedEl = Array.prototype.slice.call(fieldElement.options).find(function (el) {
                    return el.value == fieldValue;
                });

                if (!selectedEl) {
                    displayName = '';
                } else {
                    displayName = selectedEl.innerHTML;
                }
            }

            var formSetType = updateElement.getAttribute('data-form-set');

            if (formSetType && formSetType.toLocaleLowerCase() == 'attr') {
                updateElement.setAttribute('data-' + fieldName, displayName);
            } else {
                if (updateElement.querySelector("span")) {
                    updateElement.querySelector("span").innerHTML = displayName;
                } else {
                    updateElement.innerHTML = displayName;
                }
            }
        }
    }

    /**
     * Gets called if the generic validation is failed. Resets the error container and element class.
     * @param {any} visualizerItem
     * @param {any} element
     * @param {any} value
     */
    function submitValidationFailedFunc(visualizerItem, element, value) {

        let form = visualizerItem.parent('.am-form');

        if (form == null) {
            return false;
        }

        //Do error container magic
        let notificationContainer = form.querySelector('.global-notification-container.notification-container');

        if (notificationContainer == null) {
            return false;
        }

        if (notificationContainer.classList.contains('active')) {
            notificationContainer.classList.remove('active');
            notificationContainer.classList.add('no-errors');
        }

        element.classList.remove(that.inputErrorClass);
    }

    /**
     * Validates against additional requirements to process the lottery number. (number is only valid if it starts wirh 7,8 or 9)
     * @param {any} visualizerItem
     * @param {any} element
     * @param {any} value
     * Returns true if the lottery number is valid otherwise false. (If true validation is successful)
     */
    function submitConditionFunc(visualizerItem, element, value) {

        let form = visualizerItem.parent('.am-form');

        if (form == null) {
            return false;
        }

        //Do error container magic
        let notificationContainer = form.querySelector('.global-notification-container.notification-container');

        if (notificationContainer == null) {
            return false;
        }

        if (!(value[0] == 7 || value[0] == 8 || value[0] == 9)) {

            if (notificationContainer.classList.contains('no-errors')) {
                notificationContainer.classList.remove('no-errors');
                notificationContainer.classList.add('active');
            }

            var messageContainer = notificationContainer.querySelector('.message-container');

            if (messageContainer.classList.contains('validation-summary-valid')) {
                messageContainer.classList.remove('validation-summary-valid');
                messageContainer.classList.add('validation-summary-errors');
            }

            let headlineText = window.am.base64.decode(visualizerItem.getAttribute('data-errorheadline'));
            let text = window.am.base64.decode(visualizerItem.getAttribute('data-errormessage'));
            let fieldName = visualizerItem.getAttribute('data-fieldname');

            var headlineElement = notificationContainer.querySelector('.headline-element h3');

            if (headlineElement) {
                headlineElement.innerHTML = headlineText;
            }

            if (text) {
                let messageElement = notificationContainer.querySelector('.message .additional-message');

                if (messageElement) {
                    messageElement.innerHTML = text;
                }
            }

            let errorList = messageContainer.querySelector('ul');
            errorList.innerHTML = '';

            let errorMsgLi = document.createElement('li');
            errorMsgLi.innerHTML = '<a href="#' + fieldName + '">Losnummer</a>';

            errorList.appendChild(errorMsgLi);

            element.classList.add(that.inputErrorClass);

            return false;
        }

        if (notificationContainer.classList.contains('active')) {
            notificationContainer.classList.remove('active');
            notificationContainer.classList.add('no-errors');
        }

        element.classList.remove(that.inputErrorClass);

        return true;
    }

}

window.am.chargeBack.init();